import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { BuildingContactRoleView } from '@api-proxies';
import { BuildingContactRoleService } from '@http/clients/building-contact-role.service';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../base/form-editor-base';

@Component({
    selector: 'app-company-roles-form-editor',
    templateUrl: './company-roles-form-editor.component.html',
    styleUrls: ['./company-roles-form-editor.component.scss'],
    providers: [createValueAccessorProvider(CompanyRolesFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class CompanyRolesFormEditorComponent extends FormEditorBase<BuildingContactRoleView[]> implements OnInit {
    // Inputs signals
    value = input<BuildingContactRoleView[]>();
    readonly = input<boolean>(false);
    placeholderText = input<string>('Select Company Roles');

    private readonly buildingContactRoleService = inject(BuildingContactRoleService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.loadCompanyRoles();
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): BuildingContactRoleView[] {
        return this.selectedItems() || [];
    }

    protected override mapValueToSelectedItems(value: BuildingContactRoleView[]): any[] {
        return value || [];
    }

    private async loadCompanyRoles(): Promise<void> {
        const roles = await this.buildingContactRoleService.search();
        this.items.set(roles);
    }
}
